import React from 'react';
// import './ContactUs.css';

function ContactUs() {
  return (
    <div className="ContactUs">
        <p>
        ContactUs
        </p>
    </div>
  );
}

export default ContactUs;
